import Helper from './Helper';
import HeaderStateHandler from './HeaderStateHandler';

class SearchHandler {
  constructor() {
    this.toggler = this.constructor.getToggler();
    this.closer = document.querySelector('#js-close-header-search');
    this.search = this.constructor.getSearch();
    this.searchOpen = false;
    if(this.toggler){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.toggler.addEventListener('click', () => {
      this.togglerClicked();
    });

    this.closer.addEventListener('click', () => {
      this.closeSearch();
    });

  }

  closeSearch(){
    Helper.slideClose(this.search);
    Helper.removeClass(this.toggler, 'active');
    this.searchOpen = false;
  }

  static closeSearch(){
    Helper.slideClose(this.getSearch());
    Helper.removeClass(this.getToggler(), 'active');
    this.searchOpen = false;
  }

  openSearch(){
    HeaderStateHandler.searchHandler();
    Helper.slideOpen(this.search);
    Helper.addClass(this.toggler, 'active');
    this.searchOpen = true;
    this.search.querySelector('input').focus();
  }

  togglerClicked(){
    if(this.searchOpen){
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  static getSearch(){
    return document.querySelector('#js-header-search');
  }

  static getToggler(){
    return document.querySelector('#js-search-toggler');
  }


  static isSearchOpen(){
    return Helper.hasClass(document.querySelector('#js-search-toggler'), 'active');
  }

} export default SearchHandler;
